var LaravelElixirBundle = (function (exports) {
'use strict';

var form = document.querySelector('.signup-form');
var navForm = document.querySelector('.nav-signup-form');
var navFormDT = document.querySelector('.nav-signup-form-DT');

//attach listener to regular signup form
if (form.attachEvent) {
    form.attachEvent("submit", processForm);
} else {
    form.addEventListener("submit", processForm);
}

//attach listener to nav signup
if (navForm.attachEvent) {
    navForm.attachEvent("submit", processNavForm);
} else {
    navForm.addEventListener("submit", processNavForm);
}

//attach listener to nav signup for Desktop
if (navFormDT.attachEvent) {
    navForm.attachEvent("submit", processNavFormDT);
} else {
    navFormDT.addEventListener("submit", processNavFormDT);
}


function processForm(e) {
    if (e.preventDefault) { e.preventDefault(); }
    var email = document.querySelector('#main-email-signup').value;
    var formData = new FormData();
    formData.append('email',email);
    var url = 'https://middleware.thereviewpage.com/api/submit-subscriber';

    //Fire tag manager event for email submission
    TagManager.fireEvent('emailsubmit',{});

    axios.post(url,formData)
        .then(function (response) {
            //handle success
            if(response.data == "success"){
                form.style.display = "none";
                document.querySelector('.signup').style.display="flex";
                document.querySelector('.success-message').style.display = "block";
            } else if (response.data.email != null){
                console.log(response.data);
                document.querySelector('.error-message').innerHTML = response.data.email;
            } else {
                TagManager.fireEvent('emailfail',{});
                alert('Something went wrong - please try again. If the problem persists, contact us.');
            }


        })
        .catch(function (response) {
            console.log(response);
            console.log(response.data);
            if(response.data == "success"){
                form.style.display = "none";
                document.querySelector('.signup').style.display="flex";
                document.querySelector('.success-message').style.display = "block";
            } else if (response.data.email != null){
                console.log(response.data);
                document.querySelector('.error-message').innerHTML = response.data.email;
            } else {
                TagManager.fireEvent('emailfail',{});
                alert('Something went wrong - please try again. If the problem persists, contact us.');
            }
        });
    // You must return false to prevent the default form behavior
    return false;
}

function processNavForm(e) {
    if (e.preventDefault) { e.preventDefault(); }
    var email = document.querySelector('#nav-email-signup').value;
    var formData = new FormData();
    formData.append('email',email);
    var url = 'https://middleware.thereviewpage.com/api/submit-subscriber';

    //Fire tag manager event for email submission
    TagManager.fireEvent('emailsubmit',{});

    axios.post(url,formData)
        .then(function (response) {
            if(response.data == "success"){
                navForm.style.display = "none";
                document.querySelector('.nav-signup').style.display="flex";
                document.querySelector('.nav-success-message').style.display = "block";
            } else if (response.data.email != null){
                document.querySelector('.nav-error-message').innerHTML = response.data.email;
            } else {
                TagManager.fireEvent('emailfail',{});
                alert('Something went wrong - please try again. If the problem persists, contact us.');
            }
        })
        .catch(function (response) {
            if(response.data == "success"){
                navForm.style.display = "none";
                document.querySelector('.nav-signup').style.display="flex";
                document.querySelector('.nav-success-message').style.display = "block";
            } else if (response.data.email != null){
                document.querySelector('.nav-error-message').innerHTML = response.data.email;
            } else {
                TagManager.fireEvent('emailfail',{});
                alert('Something went wrong - please try again. If the problem persists, contact us.');
            }
        });
    // You must return false to prevent the default form behavior
    return false;
}

function processNavFormDT(e) {
    if (e.preventDefault) { e.preventDefault(); }
    var email = document.querySelector('#nav-email-signup-DT').value;
    var formData = new FormData();
    formData.append('email',email);
    var url = 'https://middleware.thereviewpage.com/api/submit-subscriber';

    //Fire tag manager event for email submission
    TagManager.fireEvent('emailsubmit',{});

    axios.post(url,formData)
        .then(function (response) {
            if(response.data == "success"){
                navFormDT.style.display = "none";
                document.querySelector('.nav-signup-DT').style.display="flex";
                document.querySelector('.nav-success-message-DT').style.display = "block";
            } else if (response.data.email != null){
                document.querySelector('.nav-error-message-DT').innerHTML = response.data.email;
            } else {
                TagManager.fireEvent('emailfail',{});
                alert('Something went wrong - please try again. If the problem persists, contact us.');
            }

        })
        .catch(function (response) {
            if(response.data == "success"){
                navFormDT.style.display = "none";
                document.querySelector('.nav-signup-DT').style.display="flex";
                document.querySelector('.nav-success-message-DT').style.display = "block";
            } else if (response.data.email != null){
                document.querySelector('.nav-error-message-DT').innerHTML = response.data.email;
            } else {
                TagManager.fireEvent('emailsubmit',{});
                alert('Something went wrong - please try again. If the problem persists, contact us.');
            }
        });
    // Must return false to prevent the default form behavior
    return false;
}

return exports;

}({}));
//# sourceMappingURL=email-subscribeB.js.map
